import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../api/axiosConfig";
import { toast } from "react-toastify";
import { useAuth } from "./AuthContext";

const ResourceContext = createContext();
export const useResources = () => useContext(ResourceContext);

export const ResourceProvider = ({ children }) => {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  // FETCH
  const fetchResources = async () => {
    if (!user?.id) return;
    setLoading(true);
    try {
      const res = await api.get('/resources');
      const data = Array.isArray(res.data) ? res.data : (res.data?.data || []);
      setResources(data);
    } catch (err) {
      console.error(err);
      console.warn("Failed to load resources:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { 
      if (user && user.id) {
          fetchResources(); 
      } else {
          setResources([]);
      }
  }, [user]);

  // ADD
  const addResource = async (data) => {
    try {
        await api.post('/resources', data);
        fetchResources(); // Refresh List
        return true;
    } catch (err) {
        toast.error("Add failed");
        return false;
    }
  };

  // UPDATE
  const updateResource = async (id, data) => {
    try {
        await api.put(`/resources/${id}`, data);
        fetchResources(); // Refresh List
        return true;
    } catch (err) {
        toast.error("Update failed");
        return false;
    }
  };

  // DELETE
  const deleteResource = async (id) => {
    try {
        await api.delete(`/resources/${id}`);
        setResources(prev => prev.filter(r => r.id !== id));
        toast.success("Deleted successfully");
    } catch (err) {
        toast.error("Delete failed");
    }
  };

  return (
    <ResourceContext.Provider value={{ resources, loading, addResource, updateResource, deleteResource }}>
      {children}
    </ResourceContext.Provider>
  );
};